module.exports = __webpack_public_path__ + "static/media/dp.499e849a.jpg";